import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Captain from "../pages/captain";
import Settings from "../pages/dashboard/settings.js";
import ProfileEdit from "../pages/dashboard/profileEdit.js";
import SettingsEdit from "../pages/dashboard/settingsEdit.js";
import Support from "../pages/dashboard/support.js";
import TokenBalance from "../pages/dashboard/tokenBalance.js";
import ModuleList from "../pages/dashboard/moduleList.js";
import Store from "../pages/dashboard/store.js";
import StoreModuleDetail from "../pages/dashboard/storeModuleDetail.js";
import AstrologerDetail from "../pages/dashboard/astrologerDetail.js";
import Login from "../pages/login.js";
import ForgotPassword from "../pages/forgotPassword.js";
import ResetPassword from "../pages/resetPassword.js";
import AffirmationPage from "../pages/affirmationPage.js";
import Request from "../pages/request.js";
import AffirmationSuggestionSingle from "../components/modules/affirmationSuggestion/affirmationSuggestionSingle.js";
import MeditationInside from "../components/modules/meditation/meditationInside.js";
import NewYearWishForm from "../components/modules/newYearWishes/newYearWishForm.js";
import NewYearWishSuccess from "../components/modules/newYearWishes/newYearWishSuccess.js";
import NewAccount from "../components/modules/newAccount.js";
import NewCapsule from "../components/modules/timeCapsule/newCapsule.js";
import HumanDesignMap from "../components/modules/humanDesign/HumanDesignMap.js";
import HumanDesignAnalysis from "../components/modules/humanDesign/HumanDesignAnalysis.js";

// Ana sayfa yönlendirme component'i
function HomeRedirect() {
  useEffect(() => {
    window.location.href = "/login";
  }, []);
  return null;
}

function AppRouter() {
  return (
    <div>
      <Routes>
        <Route path="/:id/11" element={<NewAccount />} />
        <Route path="/:id/new-capsule" element={<NewCapsule />} />
        <Route path="/:id/new-year-wishes" element={<NewYearWishForm />} />
        <Route path="/:id/13/map" element={<HumanDesignMap />} />
        <Route path="/:id/13/analysis" element={<HumanDesignAnalysis />} />
        <Route path="/:id/:moduleId" element={<Captain />} />
        <Route path="/:id" element={<Captain />} />
        <Route path="/" element={<HomeRedirect />} />

        <Route path="/:id/settings" element={<Captain><Settings /></Captain>} />
        <Route path="/:id/settings/profile" element={<Captain><ProfileEdit /></Captain>} />
        <Route path="/:id/settings/edit" element={<Captain><SettingsEdit /></Captain>} />
        <Route path="/:id/settings/support" element={<Captain><Support /></Captain>} />
        <Route path="/:id/settings/token-balance" element={<Captain><TokenBalance /></Captain>} />
        <Route path="/:id/module-list" element={<Captain><ModuleList /></Captain>} />
        <Route path="/:id/astrologer/:astrologerId" element={<Captain noFooter={true}><AstrologerDetail /></Captain>} />
        <Route path="/:id/store" element={<Captain><Store /></Captain>} />
        <Route path="/:id/store/:packageId" element={<Captain><StoreModuleDetail /></Captain>} />
        {/* <Route path="/test" element={<Test />} /> */}
        <Route path="/:id/request" element={<Request />} />
        <Route
          path="/:id/:moduleId/affirmation"
          element={<AffirmationPage />}
        />
        <Route
          path="/:id/:moduleId/meditation"
          element={<MeditationInside />}
        />
        <Route
          path="/:id/:moduleId/affirmation-suggestion"
          element={<AffirmationSuggestionSingle />}
        />
        <Route
          path="/:id/17/new"
          element={<NewYearWishForm />}
        />
        <Route
          path="/:id/17/success"
          element={<NewYearWishSuccess />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/:id/login" element={<Login />} />
        <Route path="/:id/forgot-password" element={<ForgotPassword />} />
        <Route path="/:id/reset-password" element={<ResetPassword />} />
      </Routes>
    </div>
  );
}

export default AppRouter;
